webpackJsonp([90675113806994],{

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _button = __webpack_require__(37);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GetStartedPackageButton = function GetStartedPackageButton(_ref) {
	  var text = _ref.text,
	      color = _ref.color,
	      url = _ref.url;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'tc' },
	    _react2.default.createElement(
	      _button2.default,
	      {
	        link: url,
	        style: { backgroundColor: color },
	        target: '_blank',
	        isStretch: true
	      },
	      text
	    )
	  );
	};
	
	GetStartedPackageButton.propTypes = {
	  text: _propTypes2.default.string
	};
	
	exports.default = GetStartedPackageButton;
	module.exports = exports['default'];

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(201);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GetStartedPackage = function GetStartedPackage(_ref) {
	  var plan = _ref.plan,
	      price = _ref.price,
	      priceAbout = _ref.priceAbout,
	      revenue = _ref.revenue,
	      color = _ref.color,
	      recommended = _ref.recommended;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'tc mb5' },
	    _react2.default.createElement(
	      'h3',
	      { className: 'ttu f10 lh-title mt0 mb4 fw4' },
	      plan
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'mb5' },
	      _react2.default.createElement(
	        'p',
	        { className: 'mv0 f4 fw7 ttu lh-title' },
	        price
	      ),
	      _react2.default.createElement(
	        'p',
	        {
	          className: (0, _classnames2.default)({
	            'f11 lh-title mv0': true,
	            'light-silver': !recommended,
	            'pv1 ph3 br4 white dib ttu': recommended
	          }),
	          style: { backgroundColor: recommended && color }
	        },
	        priceAbout
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'mw300 center f12 lh-title light-silver ttu bb bw3 pv1',
	        style: { borderColor: color }
	      },
	      revenue
	    )
	  );
	};
	
	GetStartedPackage.propTypes = {
	  plan: _propTypes2.default.string,
	  price: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  priceAbout: _propTypes2.default.string
	};
	
	exports.default = GetStartedPackage;
	module.exports = exports['default'];

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(201);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GetStartedPackage = function GetStartedPackage(_ref) {
	  var children = _ref.children,
	      recommended = _ref.recommended;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'responsive-w mw440 mb5 mb0-l' },
	    _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)({
	          'bg-white br2 shadow-1 pv5 ph4 pv6-m ph5-m h-100': true,
	          'flex flex-column relative': true,
	          'z-3 scale-03 gold-border': recommended
	        })
	      },
	      children
	    )
	  );
	};
	
	GetStartedPackage.propTypes = {
	  children: _propTypes2.default.node,
	  recommended: _propTypes2.default.bool
	};
	
	exports.default = GetStartedPackage;
	module.exports = exports['default'];

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GetStartedPackage = function GetStartedPackage(_ref) {
	  var data = _ref.data,
	      title = _ref.title,
	      subtitle = _ref.subtitle;
	
	  var items = data.map(function (item, i) {
	    return _react2.default.createElement(
	      'li',
	      { key: 'plan-' + i, className: 'plan-before relative mb4 mb5-m mb6-l pl5' },
	      item
	    );
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'flex-grow-1' },
	    _react2.default.createElement(
	      'div',
	      { className: 'mb6 tc' },
	      _react2.default.createElement(
	        'h4',
	        { className: 'mv0 f6 lh-title fw7' },
	        title
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'f10 mv0' },
	        subtitle
	      )
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: 'list ma0' },
	      items
	    )
	  );
	};
	
	GetStartedPackage.propTypes = {
	  data: _propTypes2.default.array
	};
	
	exports.default = GetStartedPackage;
	module.exports = exports['default'];

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _getStartedPackageLayout = __webpack_require__(264);
	
	var _getStartedPackageLayout2 = _interopRequireDefault(_getStartedPackageLayout);
	
	var _getStartedPackageHeader = __webpack_require__(263);
	
	var _getStartedPackageHeader2 = _interopRequireDefault(_getStartedPackageHeader);
	
	var _getStartedPackageList = __webpack_require__(265);
	
	var _getStartedPackageList2 = _interopRequireDefault(_getStartedPackageList);
	
	var _getStartedPackageButton = __webpack_require__(262);
	
	var _getStartedPackageButton2 = _interopRequireDefault(_getStartedPackageButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GetStartedPackage = function GetStartedPackage(_ref) {
	  var free = _ref.free,
	      premium = _ref.premium,
	      custom = _ref.custom,
	      mainColor = _ref.mainColor;
	
	  if (free) {
	    var listData = ['LAUNCH WORKSHOP', 'Voting, casting & judge rating tools', 'Embed content on your website', 'Earn revenue with paid votes & sponsors', 'Work as a team, add multiple team members', 'Create rich contestant profiles', 'Increase engagement & social sharing', 'Revenue share: Beauty pageant 50% / 50% Next Miss'];
	
	    return _react2.default.createElement(
	      _getStartedPackageLayout2.default,
	      { recommended: true },
	      _react2.default.createElement(_getStartedPackageHeader2.default, {
	        plan: 'Premium plan',
	        price: 'Free',
	        priceAbout: '+ earn revenue with paid votes & sponsors',
	        revenue: '50% (YOU) / 50% REVENUE SHARE',
	        color: mainColor
	      }),
	      _react2.default.createElement(_getStartedPackageList2.default, {
	        title: 'Premium Plan includes',
	        subtitle: 'All these great features:',
	        data: listData
	      }),
	      _react2.default.createElement(_getStartedPackageButton2.default, {
	        text: 'Get started',
	        color: mainColor,
	        url: 'https://admin.choicely.com/brand/create'
	      })
	    );
	  }
	
	  if (custom) {
	    var _listData = ['We develop your own beauty app', 'High volume traffic management ', 'Dedicated account manager', 'Advanced analytics', 'Custom feature development', 'Custom integrations', 'Gold Support', 'Revenue share: To be negotiated'];
	
	    return _react2.default.createElement(
	      _getStartedPackageLayout2.default,
	      null,
	      _react2.default.createElement(_getStartedPackageHeader2.default, {
	        plan: 'Gold plan',
	        price: 'Custom',
	        priceAbout: 'based on volume & number of shows',
	        color: mainColor
	      }),
	      _react2.default.createElement(_getStartedPackageList2.default, {
	        title: 'Gold Plan includes',
	        subtitle: 'These optional services:',
	        data: _listData
	      }),
	      _react2.default.createElement(_getStartedPackageButton2.default, {
	        text: 'Contact us',
	        color: mainColor,
	        url: 'https://calendly.com/choicely'
	      })
	    );
	  }
	
	  return null;
	};
	
	GetStartedPackage.propTypes = {
	  free: _propTypes2.default.bool
	};
	
	exports.default = GetStartedPackage;
	module.exports = exports['default'];

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getStartedPackage = __webpack_require__(266);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getStartedPackage).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 201:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _sectionBusinessModel = __webpack_require__(296);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sectionBusinessModel).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mainSectionLayout = __webpack_require__(29);
	
	var _mainSectionLayout2 = _interopRequireDefault(_mainSectionLayout);
	
	var _pageTopBar = __webpack_require__(30);
	
	var _pageTopBar2 = _interopRequireDefault(_pageTopBar);
	
	var _getStartedPackage = __webpack_require__(267);
	
	var _getStartedPackage2 = _interopRequireDefault(_getStartedPackage);
	
	__webpack_require__(451);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionGetStartedPackage = function SectionGetStartedPackage() {
	  return _react2.default.createElement(
	    _pageTopBar2.default,
	    { iconName: 'handshakes', text: 'Business Model' },
	    _react2.default.createElement(
	      _mainSectionLayout2.default,
	      {
	        title: 'Business Model',
	        about: 'Our business model is simple'
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'flex flex-wrap' },
	        _react2.default.createElement(_getStartedPackage2.default, { free: true, mainColor: '#cb9f3f' }),
	        _react2.default.createElement(_getStartedPackage2.default, { custom: true, mainColor: '#000' })
	      )
	    )
	  );
	};
	
	exports.default = SectionGetStartedPackage;
	module.exports = exports['default'];

/***/ }),

/***/ 451:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(23);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _sectionBusinessModel = __webpack_require__(295);
	
	var _sectionBusinessModel2 = _interopRequireDefault(_sectionBusinessModel);
	
	var _business_model = __webpack_require__(654);
	
	var _business_model2 = _interopRequireDefault(_business_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BusinessModel = function (_Component) {
	  _inherits(BusinessModel, _Component);
	
	  function BusinessModel() {
	    _classCallCheck(this, BusinessModel);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  BusinessModel.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Business Model'
	        ),
	        _react2.default.createElement('meta', { property: 'og:title', content: 'Business Model' }),
	        _react2.default.createElement('meta', { property: 'og:description', content: 'Our business model is simple' }),
	        _react2.default.createElement('meta', { property: 'og:image', content: 'https://nextmiss.com' + _business_model2.default }),
	        _react2.default.createElement('meta', { property: 'og:url', content: 'https://nextmiss.com/business_model/' }),
	        _react2.default.createElement('meta', { property: 'og:image:alt', content: 'Business Model - Next Miss' })
	      ),
	      _react2.default.createElement(_sectionBusinessModel2.default, null)
	    );
	  };
	
	  return BusinessModel;
	}(_react.Component);
	
	exports.default = BusinessModel;
	module.exports = exports['default'];

/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/business_model.27412aa7.png";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-business-model-js-17dbd79036ca2c89a00c.js